import React, { useEffect } from 'react';
// import Viewer from '../../forge/Viewer';
import Projects from '../../Data/sampleprojectdata.json';
import Button from '@mui/material/Button';

const activeProjec = Projects.find(project => project.name === localStorage.getItem('projectName'))

const Modal = props => {
    if (!props.show) {
        return null
    }

    const closeOnEscapeKeyDown = (e) => {
        if ((e.charCode || e.keyCode) === 27) {
            props.onClose()
        }
    };

    // useEffect(() => {        
    //     document.body.addEventListener('keydown', closeOnEscapeKeyDown)
    //     return function cleanup() {
    //         document.body.removeEventListener('keydown', closeOnEscapeKeyDown)
    //     }
    // }, []);


    return (
        <div className="modal" onClick={props.onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modeal-header">
                    <h4 className="modal-title">UtilityContent.com Configurator</h4>
                </div>
                <div className="modal-body">
                    <iframe src="http://localhost:3001/previews" height="700" width="1000" style={{ 'border': 'none' }} ></iframe>
                    {/* {activeProjec.modelUrn && <Viewer
                      key={Math.random()}
                      viewerDiv={'forgeViewer'}
                      urn={activeProjec.modelUrn}
                      showSensors={true}
                      extensions={['NestedViewerExtension']}
                      hasDwg={1}
                    /> } */}
                </div>
                <div className="modal-footer">
                    {/* <Button id="configBtn" variant="contained" color="primary">Insert Model</Button> */}
                    <button id="configBtn" className="esri-button">Insert Model</button><br />
                </div>
            </div>
        </div>
    )
}

export default Modal